"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FontColorContrast_1 = require("./FontColorContrast");
function fontColorContrast(hexColorOrRedOrArray, greenOrThreshold, blue, threshold) {
    const fcc = new FontColorContrast_1.FontColorContrast(hexColorOrRedOrArray, greenOrThreshold, blue, threshold);
    return fcc.getColor();
}
exports.default = fontColorContrast;
//# sourceMappingURL=index.js.map